import type { HelpPortalSource } from "@/lib/help-portal";
import {
  OPERATOR_HELP_ARTICLES,
  OPERATOR_HELP_CATEGORIES,
  operatorArticlesInCategory,
} from "@/lib/operator-help/articles";
import { searchOperatorHelpArticles } from "@/lib/operator-help/search";

export {
  OPERATOR_HELP_ARTICLES,
  OPERATOR_HELP_ARTICLE_IDS,
  OPERATOR_HELP_CATEGORIES,
  getOperatorHelpArticle,
  isOperatorHelpArticleId,
  operatorArticlesInCategory,
} from "@/lib/operator-help/articles";
export { searchOperatorHelpArticles } from "@/lib/operator-help/search";
export type { OperatorHelpArticleId } from "@/lib/operator-help/articles";

export const OPERATOR_HELP_PORTAL: HelpPortalSource = {
  articles: OPERATOR_HELP_ARTICLES,
  categories: OPERATOR_HELP_CATEGORIES,
  searchArticles: searchOperatorHelpArticles,
  articlesInCategory: operatorArticlesInCategory,
  indexTo: "/operator/help",
  articleTo: "/operator/help/$articleId",
  emptySearchHint:
    "Try a different word, such as compliance, needs attention, registrations, or upload.",
};
